import { render, staticRenderFns } from "./new-restriction-creator-confirm.vue?vue&type=template&id=102f6bcc"
import script from "./new-restriction-creator-confirm.vue?vue&type=script&lang=js"
export * from "./new-restriction-creator-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports